import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getGroups } from "../actions/auth.js"
import Select_Dsas from "./Select_Dsas.js"

const FilterGroupProvider = ({classname, labelId, label, selectId, name, filters, setFilters}) => {

    const dispatch = useDispatch()

    const groups = useSelector((state) => state.authentication).groups

    useEffect(() => {
        dispatch(getGroups())
    }, [])

    return (
    <Select_Dsas 
        className={classname}
        labelId = {labelId}
        label = {label}
        selectId = {selectId}
        name = {name}
        value = {filters.provider}
        items = {groups.sort((a, b) => a.name.localeCompare(b.name))}
        onChange = {(e) => setFilters(state => ({...state, [name] : e.target.value}))}
        onReset = {(e) => setFilters(state => ({...state, [name] : ''}))}>
    </Select_Dsas>)

}

export default FilterGroupProvider